import { OPENID_KEY } from '@/constants';
import { fetcher } from '@/services/graphql/fetcher/index';
import { commonUtils, storage, toast } from '@/utils';
import { fetchGetJsConfigDocument } from '../graphql/docs';
import { sceneConfig } from '@/local-conf';
// #ifdef H5
import WechatSDK from 'weixin-js-sdk';
// #endif

export default async () => {
  // 先判断缓存
  const cache = await storage.get(OPENID_KEY);
  if (!cache) {
    // 获取url参数
    const params = commonUtils.url.getAllParams(location.href);
    const H5openIdKey = params[OPENID_KEY];
    if (!H5openIdKey) {
      storage.remove(OPENID_KEY);
      locationHref();
    } else {
      // 缓存openkey
      storage.set(OPENID_KEY, H5openIdKey, 1);
    }
  }
};

/** 授权跳转 */
const locationHref = () => {
  // const authReturnUrl = 'http://localhost:5173/pages/subpack-minor/login/index';
  location.href = `https://api.scmally.startcatcher.cn/wx/inlet?channelToken=snrq0k7ry49cni771gzr&scope=snsapi_base&returnUrl=${window.location.href}&host=dev.scmally.startcatcher.cn`;
};

/** 初始化config */
export const initH5WechatSDKConfig = async () => {
  try {
    const res = await fetcher.mutation(fetchGetJsConfigDocument, {
      url: location.href,
    });

    const config = res.data.getJsConfig;

    if (config) {
      const { appId, timestamp, nonceStr, signature } = config;
      WechatSDK.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
        appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
    }
  } catch (error) {
    toast.message('初始化配置失败');
  }
};
